import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { api as rootCauseAPI } from '@saucelabs/sl-module-root-cause';

import * as types from './types';
import { selectedOwnerTransformer } from '../../util';
import { handleLocationMeta } from '../filters/actions';

export const handleChangePagination = createAction(types.CHANGE_PAGINATION);
export const cleanup = createAction(types.CLEANUP);
export const setOwnerFromQueryString = createAction(types.SET_OWNER_FROM_QUERYSTRING);
export const setJobsOwner = handleLocationMeta(
  createAction(types.SET_JOBS_OWNER), selectedOwnerTransformer);

export const getJobOwners = createApiAction(
  types.GET_JOBS_OWNERS,
  (payload) => rootCauseAPI.getJobOwners(payload),
  { meta: { skipErrorPage: true } },
);

export const getRootCauses = createApiAction(
  types.GET_ROOT_CAUSES,
  ({ params, index }) => rootCauseAPI.getRootCauses(params)
    .then(({ data }) => ({ index, results: data.results }))
    .catch((error) => ({ index, error })),
  { meta: { skipErrorPage: true } },
);

export const getFailureTests = createApiAction(
  types.GET_FAILURE_TESTS,
  (params) => rootCauseAPI.getFailureTests(params),
  { meta: { skipErrorPage: true } },
);
